import { type IconSets } from "@toruslabs/vue-components";
import {
  ArrowDownSolidIcon,
  ArrowLeftIcon,
  ArrowNarrowRightIcon,
  ArrowNarrowRightSolidIcon,
  ArrowRightIcon,
  ArrowUpSolidIcon,
  ChevronDownSolidIcon,
  ChevronRightIcon,
  ChevronRightSolidIcon,
  ChevronUpSolidIcon,
} from "@toruslabs/vue-icons/arrows";
import {
  AppleIcon,
  DiscordIcon,
  FacebookIcon,
  GithubIcon,
  GoogleIcon,
  KakaoIcon,
  LineIcon,
  LinkedinIcon,
  RedditIcon,
  TwitchIcon,
  TwitterIcon,
  WechatIcon,
} from "@toruslabs/vue-icons/auth";
import { CashSolidIcon, CreditCardSolidIcon, SupportSolidIcon } from "@toruslabs/vue-icons/bank";
import { PresentationChartLineIcon } from "@toruslabs/vue-icons/charts";
import { AnnotationSolidIcon, BellSolidIcon, ChatAltSolidIcon, TagSolidIcon } from "@toruslabs/vue-icons/chatting";
import { WifiIcon } from "@toruslabs/vue-icons/connection";
import { HappyIcon } from "@toruslabs/vue-icons/emoji";
import {
  ArchiveSolidIcon,
  ClipboardListSolidIcon,
  ColorSwatchSolidIcon,
  DocumentDuplicateIcon,
  DocumentDuplicateSolidIcon,
  DocumentReportSolidIcon,
  DocumentTextSolidIcon,
  DuplicateSolidIcon,
  FolderAddIcon,
  FolderRemoveSolidIcon,
} from "@toruslabs/vue-icons/file";
import { ClockIcon, ClockSolidIcon } from "@toruslabs/vue-icons/gadgets";
import { CubeSolidIcon, ViewGridSolidIcon } from "@toruslabs/vue-icons/grid";
import { InboxInSolidIcon, LinkIcon, MailIcon, MailOpenSolidIcon, PencilAltSolidIcon, PencilIcon } from "@toruslabs/vue-icons/mail";
import {
  GlobeAltSolidIcon,
  HomeSolidIcon,
  LibrarySolidIcon,
  MoonSolidIcon,
  OfficeSolidIcon,
  SearchSolidIcon,
  SelectorIcon,
} from "@toruslabs/vue-icons/maps";
import { DotsHorizontalIcon, MenuAltTwoSolidIcon } from "@toruslabs/vue-icons/menu";
import { RefreshIcon, ReplySolidIcon } from "@toruslabs/vue-icons/music";
import {
  CheckCircleIcon,
  CheckCircleSolidIcon,
  CheckIcon,
  ExclamationCircleSolidIcon,
  ExclamationSolidIcon,
  FireSolidIcon,
  LightBulbSolidIcon,
  LightningBoltSolidIcon,
  LogoutIcon,
  PlusIcon,
  PlusSolidIcon,
  QuestionMarkCircleIcon,
  QuestionMarkCircleSolidIcon,
  StarSolidIcon,
  XCircleSolidIcon,
  XIcon,
  XSolidIcon,
} from "@toruslabs/vue-icons/notifications";
import {
  AdjustmentsSolidIcon,
  CalendarSolidIcon,
  CogIcon,
  CogSolidIcon,
  PuzzleSolidIcon,
  SparklesSolidIcon,
  SunSolidIcon,
  TrashIcon,
  TrashSolidIcon,
} from "@toruslabs/vue-icons/others";
import {
  EyeOffSolidIcon,
  EyeSolidIcon,
  IdentificationSolidIcon,
  InformationCircleIcon,
  InformationCircleSolidIcon,
  KeySolidIcon,
  LockClosedSolidIcon,
  LockOpenSolidIcon,
  ShieldCheckSolidIcon,
} from "@toruslabs/vue-icons/security";
import { CloudUploadIcon, CodeIcon, DatabaseSolidIcon, DownloadSolidIcon, QrcodeSolidIcon, TableSolidIcon } from "@toruslabs/vue-icons/software";
import { UserCircleIcon, UserCircleSolidIcon, UserGroupSolidIcon } from "@toruslabs/vue-icons/users";

import AuthIcon from "./Auth.vue";
import AwsCognitoIcon from "./AwsCognito.vue";
import ClipboardCopyIcon from "./ClipboardCopy.vue";
import ExternalWalletsIcon from "./ExternalWallets.vue";
import FiatOnrampIcon from "./FiatOnramp.vue";
import FirebaseIcon from "./Firebase.vue";
import GoogleActiveIcon from "./Google.vue";
import GroupIcon from "./Group.vue";
import InfuraIcon from "./InfuraIcon.vue";
import JwtIcon from "./JwtIcon.vue";
import LoginAuth from "./LoginAuth.vue";
import LoginGuidelines from "./LoginGuidelines.vue";
import LoginIntegrations from "./LoginIntegrations.vue";
import LoginProjects from "./LoginProjects.vue";
import LoginShare from "./LoginShare.vue";
import LoginSupport from "./LoginSupport.vue";
import LoginWhitelabel from "./LoginWhitelabel.vue";
import MetaMaskDeveloperIcon from "./MetaMaskDeveloperIcon.vue";
import MetaMaskIcon from "./MetaMaskIcon.vue";
import NftIcon from "./NftIcon.vue";
import PasskeysIcon from "./Passkeys.vue";
import PregeneratedWalletIcon from "./PregeneratedWallet.vue";
import PushPinIcon from "./PushPinIcon.vue";
import ScanQRIcon from "./ScanQR.vue";
import SmartAccountIcon from "./SmartAccountIcon.vue";
import SMSOtpIcon from "./SMSOtp.vue";
import TagIcon from "./Tag.vue";
import TokenIcon from "./TokenIcon.vue";
import Uncheck from "./Uncheck.vue";
import WalletConnectIcon from "./WalletConnectIcon.vue";
import WalletSolidCogIcon from "./WalletSolidCogIcon.vue";
// TODO: add icon to torus UI
import WalletSolidIcon from "./WalletSolidIcon.vue";
import WalletSolidIconGradient from "./WalletSolidIconGradient.vue";

export default {
  LoginGuidelines,
  LoginProjects,
  LoginShare,
  LoginSupport,
  LoginAuth,
  LoginIntegrations,
  LoginWhitelabel,
  Uncheck,
  ExclamationCircleSolidIcon,
  DotsHorizontalIcon,
  InboxInSolidIcon,
  InformationCircleSolidIcon,
  ArchiveSolidIcon,
  PencilAltSolidIcon,
  DocumentTextSolidIcon,
  CreditCardSolidIcon,
  FireSolidIcon,
  ColorSwatchSolidIcon,
  ChatAltSolidIcon,
  DatabaseSolidIcon,
  HappyIcon,
  SearchSolidIcon,
  CheckCircleIcon,
  DocumentDuplicateIcon,
  DocumentDuplicateSolidIcon,
  ViewGridSolidIcon,
  ReplySolidIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  PlusIcon,
  TrashSolidIcon,
  CogIcon,
  CheckCircleSolidIcon,
  LockClosedSolidIcon,
  LockOpenSolidIcon,
  TrashIcon,
  MenuAltTwoSolidIcon,
  BellSolidIcon,
  QuestionMarkCircleIcon,
  QuestionMarkCircleSolidIcon,
  MoonSolidIcon,
  XSolidIcon,
  StarSolidIcon,
  PlusSolidIcon,
  DuplicateSolidIcon,
  ArrowNarrowRightIcon,
  ArrowNarrowRightSolidIcon,
  PuzzleSolidIcon,
  CodeIcon,
  LibrarySolidIcon,
  AnnotationSolidIcon,
  CalendarSolidIcon,
  DocumentReportSolidIcon,
  FolderRemoveSolidIcon,
  CogSolidIcon,
  SelectorIcon,
  CloudUploadIcon,
  TableSolidIcon,
  CubeSolidIcon,
  EyeSolidIcon,
  EyeOffSolidIcon,
  LinkIcon,
  PencilIcon,
  LightningBoltSolidIcon,
  OfficeSolidIcon,
  FolderAddIcon,
  UserGroupSolidIcon,
  CashSolidIcon,
  ChevronDownSolidIcon,
  ChevronRightIcon,
  ChevronRightSolidIcon,
  ChevronUpSolidIcon,
  XCircleSolidIcon,
  XIcon,
  InformationCircleIcon,
  AppleIcon,
  DiscordIcon,
  FacebookIcon,
  GithubIcon,
  GoogleIcon,
  KakaoIcon,
  LineIcon,
  LinkedinIcon,
  RedditIcon,
  TwitchIcon,
  TwitterIcon,
  WechatIcon,
  MailIcon,
  PresentationChartLineIcon,
  RefreshIcon,
  SunSolidIcon,
  ShieldCheckSolidIcon,
  QrcodeSolidIcon,
  ArrowDownSolidIcon,
  ArrowUpSolidIcon,
  SparklesSolidIcon,
  ClockSolidIcon,
  ClockIcon,
  KeySolidIcon,
  GlobeAltSolidIcon,
  WalletSolidIcon,
  WalletSolidIconGradient,
  WalletConnectIcon,
  NftIcon,
  TokenIcon,
  TagSolidIcon,
  ClipboardCopyIcon,
  SupportSolidIcon,
  CheckIcon,
  LightBulbSolidIcon,
  ClipboardListSolidIcon,
  WifiIcon,
  HomeSolidIcon,
  DownloadSolidIcon,
  MailOpenSolidIcon,
  AdjustmentsSolidIcon,
  SmartAccountIcon,
  FiatOnrampIcon,
  TagIcon,
  PregeneratedWalletIcon,
  UserCircleSolidIcon,
  IdentificationSolidIcon,
  PasskeysIcon,
  SMSOtpIcon,
  ExternalWalletsIcon,
  AuthIcon,
  AwsCognitoIcon,
  FirebaseIcon,
  GoogleActiveIcon,
  GroupIcon,
  MetaMaskIcon,
  MetaMaskDeveloperIcon,
  JwtIcon,
  InfuraIcon,
  ScanQRIcon,
  WalletSolidCogIcon,
  ExclamationSolidIcon,
  LogoutIcon,
  UserCircleIcon,
  PushPinIcon,
} as unknown as IconSets;
